<template>
  <div class="college-header">
    <div class="college">
      <div
        v-if="logoUrl"
        class="avatar"
        :style="{ backgroundImage: `url(${logoUrl})` }"
      />
      <div v-else class="avatar default" />

      <div>
        <h1 style="color: white">{{ name }}</h1>
        <div class="sub">Active for {{ activeSince }}</div>
      </div>
    </div>

    <div class="actions">
      <share-button />
    </div>

    <p class="print-description print-only text-right">
      <em>
        Printed on {{ new Date().toLocaleString() }}. Check your BetterMynd
        dashboard for current information.
      </em>
    </p>
  </div>
</template>

<script>
import moment from 'moment';
import RequestCreditsModal from './Credits/RequestCreditsModal.vue';
import ShareButton from './ShareButton.vue';

export default {
  name: 'Header',

  components: {
    ShareButton
  },

  inject: ['collegeDetailsReport'],

  computed: {
    name() {
      return this.collegeDetailsReport.data.name;
    },
    logoUrl() {
      return this.collegeDetailsReport.data.logoUrl;
    },
    activeSince() {
      const joined = moment(this.collegeDetailsReport.data.activeSince);
      const now = moment();

      return this.calcDifference(joined, now, ['year', 'month', 'day'])
    }
  },

  methods: {
    openModal() {
      this.$modal.show(RequestCreditsModal);
    },
    calcDifference(joined, now, units){
      const segments = [];

      for(const unit of units) {
        const time = now.diff(joined, unit);
        if(time > 0) {
          if(time > 1){
            segments.push(`${time} ${unit}s`)
          } else {
            segments.push(`${time} ${unit}`)
          }
          joined = joined.add(time, unit);
        }
      }

      if(segments.length === 0)
        return `less than a ${units[units.length - 1]}`

      return segments.reduce(this.reduceSegments)
    },
    reduceSegments(prev, curr, index, arr){
      const isLastSegment = index === arr.length - 1;
      const joiner = isLastSegment ? ', and ' : ', '
      return `${prev}${joiner}${curr}`;
    },
  }
};
</script>

<style lang="scss" scoped>
.college-header {
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  line-height: 1.05;

  @media screen and (min-width: $sm-min) {
    justify-content: space-between;
    flex-direction: row;
  }

  .college {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
  }

  .avatar {
    @include background-cover;
    @include border-radius(50%);

    display: inline-block;
    background-color: $dark-blue;
    height: 28px;
    min-width: 28px;
    width: 28px;
    margin-right: 8px;

    &.default {
      background-image: url('~@/assets/img/default-icon.jpg');
    }

    @media (min-width: $sm-min) {
      margin-right: 16px;
      height: 60px;
      min-width: 60px;
      width: 60px;
    }
  }

  h1 {
    font-family: $sans;
    font-size: 1.33rem;
    display: inline-block;
    margin: 0 0 0.3rem 0;
    line-height: inherit;
    letter-spacing: 0.05rem;
  }

  .sub {
    font-size: 16px;
    font-weight: 500;
    color: #bfc0c7;
  }

  .nav {
    margin-left: 0.5rem;

    .instruct {
      font-size: 0.9rem;
    }

    .dropdown-button {
      height: 28px;
      padding: 0;
      width: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;

      ::v-deep .nav-link {
        padding: 0;
        width: 100%;
        height: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }

      @media (min-width: $sm-min) {
        height: 40px;
        width: 40px;
      }
    }

    .icon.nav-option {
      margin-right: 8px;
      color: $blue;
    }
  }

  .actions {
    padding-top: 2rem;
    @media screen and (min-width: $sm-min) {
      padding-top: 0;
    }
  }

  @media print {
    .print-description {
      margin-bottom: 0;
      display: block;
      flex: 1;
      line-height: 1.5;
    }

    padding: 0 1rem;

    .avatar {
      display: none;
    }

    h1 {
      font-size: 18px;
      letter-spacing: 0;
    }
  }
}
</style>
